import { LORAX_LIGHT, MARIGOLD_LIGHT, THUNDERDOME_LIGHT } from 'HubStyleTokens/colors';
export const UPGRADE_POPOVER_CONTENT_I18N_KEYS = {
  'calling-channel-account-upgrade': 'callingChannelAccountUpgrade',
  'calling-channel-increase-channel-limit-inbox': 'callingChannelAccountUpgrade',
  'crm-sequences-access': 'crmSequencesAccess',
  'data-quality-command-center-contacts': 'dataQualityCommandCenterContacts',
  'data-quality-command-center-companies': 'dataQualityCommandCenterContacts',
  'whatsapp-messaging-access': 'whatsappMessagingAccess',
  'prospecting-workspace-summary': 'prospectingWorkspaceSummary',
  'prospecting-workspace-leads': 'prospectingWorkspaceLeads',
  'prospecting-workspace-schedule': 'prospectingWorkspaceSchedule',
  'calling-free-account-upgrade-global-nav': 'callingFreeAccountUpgradeGlobalNav'
};
export const IMAGE_BACKGROUND_OVERRIDES = {
  'crm-sequences-access': MARIGOLD_LIGHT,
  'whatsapp-messaging-access': MARIGOLD_LIGHT,
  'prospecting-workspace-summary': MARIGOLD_LIGHT,
  'prospecting-workspace-leads': LORAX_LIGHT,
  'prospecting-workspace-schedule': THUNDERDOME_LIGHT
};
export const ILLUSTRATION_OVERRIDES = {
  'prospecting-workspace-summary': 'sales-professional',
  'prospecting-workspace-leads': 'leads',
  'prospecting-workspace-schedule': 'schedule'
};
export const TALK_TO_SALES_EXCLUDED_OVERRIDES = [];

// Localized images live in 53
// https://app.hubspot.com/files/53/?sortDirection=descending&orderBy=updated&archived=false&folderId=172839694977
export const LOCALIZED_IMAGE_OVERRIDES = {
  'crm-sequences-access': 'sequences',
  'data-quality-command-center-contacts': 'DQ',
  'data-quality-command-center-companies': 'DQ',
  'calling-free-account-upgrade-global-nav': 'calling'
};